// File: app/src/components/TopicSelector.jsx
import React from 'react';
import Select from 'react-select';

export default function TopicSelector({ topics, onTopicSelect }) {
  return (
    <div>
      <label>
        Select a Game
      </label>
      <Select
        options={topics}
        onChange={onTopicSelect}
        placeholder="Search for a game..."
        isClearable
      />
    </div>
  );
}
